import { createPopper } from '@popperjs/core';

( function( $ ) {

if($('.fmp-team__members').length){
  $('.fmp-team__members').on('click', '.fmp-team__member__details__close', function () {
    $('.fmp-team__member').removeClass('is-active');
  });

  let popupInstance = null;
  $('.fmp-team__members').on('click', '.fmp-team__member figure', function () {
    $('.fmp-team__member').removeClass('is-active');
    $(this).parent().addClass('is-active');

    if ($(this).parent().hasClass('is-active')) {
      popupCreate(this, this.nextElementSibling);
    } else {
      popupDestroy();
    }
  });

  function popupCreate(btn, popup) {
    var mediaQuery = window.matchMedia('(max-width: 767px)');
    var teamBoundary = document.querySelector('.fmp-team__members');

    popupInstance = createPopper(btn, popup, {
      placement: "auto",
      modifiers: [
        {
          name: "offset",
          options: {
            offset: () => [0, mediaQuery.matches ? 8 : 18],
          }
        },
        {
          name: 'preventOverflow',
          options: {
            boundary: teamBoundary,
          },
        },
        {
          name: "flip",
          options: {
            allowedAutoPlacements: mediaQuery.matches ? ["top", "bottom"] : ["left", "right"],
            rootBoundary: "viewport",
          }
        }
      ]
    });
  }

  function popupDestroy() {
    if (popupInstance) {
      popupInstance.destroy();
      popupInstance = null;
    }
  }

}

if ($('#departments').length) {
  $('#departments').on('change', function (e) {
    var department = $(this).val();
    var teamMember = $(this).parents('.fmp-team').find('.fmp-team__members');
    teamMember.html('<div class="fmp-loading"><svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve"> <path fill="#08618d" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"> <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" /> </path> </svg></div>');
    var data = {
      'action': 'fmp_team_filter',
      'nounce': localized.ajaxnonce,
      'department': department
    };
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: localized.ajaxurl,
      data: data,
      success: function success(response) {
        teamMember.html(response.output);
      }
    });
  });
}

} )( jQuery );
